import { getLegalDocumentVersion } from '@filmspo/legal-content';
import { useLocation } from 'react-router-dom';

import { LegalDocumentContent } from '../components/LegalDocument';

export function TermsPage() {
  const { search } = useLocation();
  const versions = new URLSearchParams(search).getAll('version');
  const version = versions.length === 0 ? undefined : versions[0];
  const terms = versions.length <= 1 ? getLegalDocumentVersion('terms', version) : undefined;
  const addendum =
    versions.length <= 1 ? getLegalDocumentVersion('festival_addendum', version) : undefined;
  if (!terms || !addendum)
    return <main className="legal-page">This legal document version is unavailable.</main>;
  return (
    <main className="legal-page">
      <div className="legal-container">
        {version === '1.0' && (
          <aside role="note">
            Historical version 1.0, superseded by the current Terms and Addendum.{' '}
            <a href="/terms">Read the current versions</a>.
          </aside>
        )}
        <LegalDocumentContent document={terms} />
        <nav className="legal-related" aria-label="Related legal document">
          <a href={addendum.publicUrl}>
            Read the separately versioned Festival/Connected-Account Addendum
          </a>
        </nav>
        <div id="festival-connected-account-addendum">
          <LegalDocumentContent document={addendum} includeTitle={false} />
        </div>
      </div>
    </main>
  );
}
